import { Component, OnDestroy } from '@angular/core';
import { getSelectedAdminPlan } from '../login/store/selectors';
import { ILoginState } from '../login/store/state';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-dentist-directory',
    templateUrl: './dentist-directory.component.html',
    standalone: false
})
export class DentistDirectoryComponent implements OnDestroy {
  luxId = 'BMT-DentistDirectoryComponent-' + this.constructor.name;
  selectedAdminPlan = toSignal(this.lux.get(getSelectedAdminPlan, this.luxId), { initialValue: '' });

  constructor(private readonly lux: Lux<{ login: ILoginState }>) {
  }


  ngOnDestroy(): void {
    this.lux.destroy(this.luxId);
  }
}
